import React from 'react';
import { Globe2 } from 'lucide-react';
const currencies = ['ARS $', 'MXN $', 'COP $', 'CLP $', 'PEN S/', 'USD $'];

/**
 * Reassures Latin American buyers that the USD price is charged
 * in their own currency at checkout.
 */
export const LocalCurrencyNote = ({
  className = ''
}: {
  className?: string;
}) => <div className={`rounded-[16px] border border-brandBlue-electric/40 bg-bg-card px-4 py-3.5 md:px-5 md:py-4 ${className}`} data-id="element-371" data-mp="v4w5a2ytb012">
    <div className="flex items-start gap-2.5" data-id="element-372" data-mp="q85qdiyquah8">
      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brandBlue-electric/15 text-brandBlue-electric" data-id="element-373" data-mp="lfmb8hker7ab">
        <Globe2 size={16} aria-hidden="true" data-id="element-374" data-mp="hesovsmm60jj" />
      </span>
      <div className="min-w-0 text-left" data-id="element-375" data-mp="cg90llkjsco0">
        <p className="font-sans font-bold uppercase tracking-[1.2px] text-[10px] md:text-[11px] text-brandBlue-electric" data-id="element-376" data-mp="chancnaxenlk">
          Pagas en tu moneda local
        </p>
        <p className="font-sans text-[11.5px] md:text-[13px] leading-[1.45] text-txt-body mt-0.5" data-id="element-377" data-mp="2ibfv81wcy05">
          El precio se convierte automáticamente al finalizar la compra. Sin
          cuentas en dólares ni trámites extra.
        </p>
      </div>
    </div>
    <div className="mt-2.5 flex flex-wrap gap-1.5" data-id="element-378" data-mp="23t0ab5mi824u">
      {currencies.map(currency => <span key={currency} className="rounded-full border border-line bg-bg-alt px-2 py-0.5 font-sans font-bold text-[9.5px] md:text-[10.5px] tracking-[0.5px] text-txt-muted" data-id="element-379" data-mp="23r5ntmvl41yn">
          {currency}
        </span>)}
    </div>
  </div>;